"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmBetPopUpView = void 0;
const ImgLoader_1 = require("@nolimit/slot-launcher/bin/loader/ImgLoader");
const PromoPanelAssetConfig_1 = require("../../config/PromoPanelAssetConfig");
const PointerStateColorSet_1 = require("@nolimit/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet");
const PromoPanelButtonIDs_1 = require("../../enums/PromoPanelButtonIDs");
const PromoPanelLabelButton_1 = require("../PromoPanelLabelButton");
const NolimitPromotionPlugin_1 = require("../../NolimitPromotionPlugin");
const PromoPanelLabelIDs_1 = require("../../enums/PromoPanelLabelIDs");
const PromoPanelTextStyles_1 = require("../../config/PromoPanelTextStyles");
const PromoPanelConfig_1 = require("../../config/PromoPanelConfig");
const Label_1 = require("@nolimit/slot-launcher/bin/gui/labels/Label");
const NolimitApplication_1 = require("@nolimit/slot-launcher/bin/NolimitApplication");
const OpenSans_1 = require("@nolimit/slot-launcher/bin/loader/font/OpenSans");
const FontStatics_1 = require("@nolimit/slot-launcher/bin/loader/font/FontStatics");
const GuiLayout_1 = require("@nolimit/slot-launcher/bin/gui/utils/GuiLayout");
const gsap_1 = require("gsap");
const CurrencyUtils_1 = require("../../utils/CurrencyUtils");
const BonusBuyPopUpContent_1 = require("./BonusBuyPopUpContent");
/**
 * Created by jonas on 2023-09-13.
 */
class ConfirmBetPopUpView extends PIXI.Container {
    get isOpen() {
        return this.visible;
    }
    constructor() {
        super();
        this.init();
    }
    resize() {
        this._background.width = NolimitApplication_1.NolimitApplication.screenBounds.width;
        this._background.height = NolimitApplication_1.NolimitApplication.screenBounds.height;
        this._background.position.set(0, 0);
        const popupY = NolimitApplication_1.NolimitApplication.isLandscape ? 0 : NolimitApplication_1.NolimitApplication.screenBounds.height - this._popUpPlate.height;
        this._popUpPlate.position.set(NolimitApplication_1.NolimitApplication.screenBounds.width * 0.5, popupY * 0.5);
    }
    openBonusBuy(callback, featureData) {
        var _a;
        let content = this.createBonusBuyContent(featureData);
        if ((_a = NolimitPromotionPlugin_1.NolimitPromotionPlugin.promoPanelGameConfiguration) === null || _a === void 0 ? void 0 : _a.replaceBonusBuyPopUpContent) {
            content = NolimitPromotionPlugin_1.NolimitPromotionPlugin.promoPanelGameConfiguration.replaceBonusBuyPopUpContent(content);
        }
        this._contentContainer.addChild(content);
        this._buttonClickCallback = callback;
        this._featureData = featureData;
        this.show();
    }
    openActionSpins(callback, asData) {
        const content = this.createActionSpinsContent(asData);
        this._contentContainer.addChild(content);
        this._buttonClickCallback = callback;
        this._featureData = asData.featureData;
        this.show();
    }
    close() {
        this._buttonClickCallback = undefined;
        this._contentContainer.removeChildren();
        if (this.blinkAnim) {
            this.blinkAnim.pause();
            this.blinkAnim = undefined;
        }
        this._featureData = undefined;
        this.hide();
    }
    init() {
        this._background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._background.tint = 0;
        this._background.alpha = 0.6;
        this._background.interactive = true;
        this._background.name = "_background";
        this._popUpPlate = new PIXI.NineSlicePlane(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.POP_UP_BG), 64, 64, 64, 64);
        this._popUpPlate.width = 640;
        this._popUpPlate.height = 700;
        this._popUpPlate.pivot.set(this._popUpPlate.width * 0.5, 0);
        this._popUpPlate.name = "_popUpPlate";
        let normalNonEmphasisColors = new PointerStateColorSet_1.PointerStateColorSet(0xFFFFFFFF, 0xFFFFFFFF, 0xFFFFFFFF, 0x33FFFFFF);
        let activeColors = new PointerStateColorSet_1.PointerStateColorSet(0xFF000000, 0xFFFFFC00, 0xFF000000, 0x33FFFC00);
        this._cancelButton = new PromoPanelLabelButton_1.PromoPanelLabelButton(PromoPanelButtonIDs_1.PromoPanelButtonIDs.POP_UP_CLOSE, NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.POPUP_CANCEL), activeColors, normalNonEmphasisColors, PromoPanelTextStyles_1.PromoPanelTextStyles.GAME_FEATURE_OK_TEXT, undefined, (0, PromoPanelLabelButton_1.createDefaultButtonStroke)());
        this._cancelButton.setSize(PromoPanelConfig_1.PromoPanelConfig.DEFAULT_LARGE_BUTTON_SIZE.width, PromoPanelConfig_1.PromoPanelConfig.DEFAULT_LARGE_BUTTON_SIZE.height);
        this._cancelButton.enable(true);
        this._cancelButton.addClickCallback(() => {
            this.buttonClicked(this._cancelButton);
        });
        this._okButton = new PromoPanelLabelButton_1.PromoPanelLabelButton(PromoPanelButtonIDs_1.PromoPanelButtonIDs.OK_BTN, NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.POPUP_OK), activeColors, normalNonEmphasisColors, PromoPanelTextStyles_1.PromoPanelTextStyles.GAME_FEATURE_OK_TEXT, undefined, (0, PromoPanelLabelButton_1.createDefaultButtonStroke)());
        this._okButton.setSize(PromoPanelConfig_1.PromoPanelConfig.DEFAULT_LARGE_BUTTON_SIZE.width, PromoPanelConfig_1.PromoPanelConfig.DEFAULT_LARGE_BUTTON_SIZE.height);
        this._okButton.enable(true);
        this._okButton.addClickCallback(() => {
            this.buttonClicked(this._okButton);
        });
        this._cancelButton.resize(30);
        this._okButton.resize(30);
        const maxSize = Math.max(this._cancelButton.width, this._okButton.width);
        this._cancelButton.setSize(maxSize, this._cancelButton.height);
        this._okButton.setSize(maxSize, this._okButton.height);
        this._okButton.pivot.set(0, 0);
        this._cancelButton.pivot.set(0, 0);
        const buttons = new PIXI.Container();
        buttons.addChild(this._cancelButton, this._okButton);
        buttons.position.set(320, 590);
        GuiLayout_1.GuiLayout.align([this._cancelButton, this._okButton], 30, GuiLayout_1.Align.LEFT, GuiLayout_1.Direction.HORIZONTAL);
        buttons.pivot.set(buttons.width * 0.5, buttons.height * 0.5);
        this._contentContainer = new PIXI.Container();
        this._contentContainer.name = "content";
        this._contentContainer.position.set(320, 48);
        this._popUpPlate.addChild(buttons, this._contentContainer);
        this.addChild(this._background, this._popUpPlate);
        this.close();
    }
    buttonClicked(btn) {
        NolimitPromotionPlugin_1.NolimitPromotionPlugin.sound.playKeypadEffect("click");
        if (this._buttonClickCallback) {
            this._buttonClickCallback(btn, this._featureData);
        }
    }
    show() {
        this.resize();
        this.visible = true;
        this._background.alpha = 0;
        gsap_1.TweenMax.to(this._background, 0.1, { alpha: 0.6 });
    }
    hide() {
        this.visible = false;
    }
    createBonusBuyContent(featureData) {
        return new BonusBuyPopUpContent_1.BonusBuyPopUpContent(featureData);
    }
    createActionSpinsContent(asData) {
        const content = new PIXI.Container();
        const topContainer = new PIXI.Container();
        topContainer.name = "Header";
        const dialogHeader = new Label_1.Label(PromoPanelLabelIDs_1.PromoPanelLabelIDs.ACTION_SPINS, PromoPanelTextStyles_1.PromoPanelTextStyles.ACTION_SPINS_SETTINGS_HEADER);
        topContainer.addChild(dialogHeader);
        if (asData.isBonusBuy) {
            const sublineStyle = new PIXI.TextStyle({
                fontFamily: OpenSans_1.OpenSans.FAMILY,
                fontSize: 14,
                fontStyle: FontStatics_1.FontStyle.NORMAL,
                fontWeight: FontStatics_1.FontWeight.BOLD,
                fill: 0x000000,
                wordWrap: true,
                wordWrapWidth: 500,
                align: "center"
            });
            const dialogHeaderSubLineString = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate("Warning! You are about to play Nolimit Bonus in Hyper speed!");
            const dialogHeaderSubLine = new Label_1.Label(dialogHeaderSubLineString, sublineStyle);
            dialogHeaderSubLine.position.set((500 - dialogHeaderSubLine.width) * 0.5, dialogHeader.y + dialogHeader.height + 15);
            const bonusLogo = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.NAV_NOLIMIT_BONUS));
            bonusLogo.scale.set(0.5, 0.5);
            bonusLogo.anchor.set(1, 0);
            bonusLogo.position.set(500, -9);
            this.blinkAnim = gsap_1.TweenMax.fromTo(bonusLogo, 0.8, { alpha: 0 }, { alpha: 1, repeat: -1, yoyo: true, ease: gsap_1.Expo.easeInOut });
            topContainer.addChild(dialogHeaderSubLine, bonusLogo);
        }
        const mainSettingsContainer = new PIXI.Container();
        const mainSettingsList = [];
        const bet = this.createBasicAsSetting(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate("Bet"), asData.bet);
        mainSettingsList.push(bet);
        const rounds = this.createBasicAsSetting(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate("Rounds"), asData.rounds + "");
        mainSettingsList.push(rounds);
        GuiLayout_1.GuiLayout.align(mainSettingsList, 40, GuiLayout_1.Align.LEFT, GuiLayout_1.Direction.HORIZONTAL);
        mainSettingsContainer.addChild(...mainSettingsList);
        mainSettingsContainer.pivot.set(mainSettingsContainer.width * 0.5, 0);
        if (asData.image) {
            const featureImage = new PIXI.Sprite(ImgLoader_1.ImgLoader.getImgTexture(asData.image));
            featureImage.anchor.set(0.5, 0.5);
            featureImage.position.set(0, 200);
            content.addChild(featureImage);
        }
        const optionsContainer = new PIXI.Container();
        const optionsList = [];
        if (asData.isBonusBuy && asData.featureData) {
            const bet = NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.betLevel.getLevel();
            const totalCost = (+bet * asData.featureData.price);
            const sum = totalCost * asData.rounds;
            optionsList.push(this.createOneLabelOption(`(${asData.bet} x ${asData.rounds} = ${CurrencyUtils_1.CurrencyUtils.formatWithDecimalCutOff(sum)})`));
        }
        if (asData.options) {
            for (let option of asData.options) {
                if (option.displayValue != undefined) {
                    optionsList.push(this.createOption(option.header || "", option.displayValue));
                }
                else {
                    optionsList.push(this.createOption(option.header || "", option.name));
                }
            }
        }
        if (asData.stopOnBonus) {
            optionsList.push(this.createOption(NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.STOP_ON_BONUS), NolimitPromotionPlugin_1.NolimitPromotionPlugin.apiPlugIn.translations.translate(PromoPanelLabelIDs_1.PromoPanelLabelIDs.YES)));
        }
        if (optionsList.length > 0) {
            GuiLayout_1.GuiLayout.align(optionsList, 10, GuiLayout_1.Align.CENTER, GuiLayout_1.Direction.VERTICAL);
            optionsContainer.addChild(...optionsList);
        }
        optionsContainer.pivot.set(optionsContainer.width * 0.5, 0);
        topContainer.position.set(-250, 0);
        mainSettingsContainer.position.set(0, 350);
        optionsContainer.position.set(0, 430);
        content.addChild(topContainer, mainSettingsContainer, optionsContainer);
        return content;
    }
    createBasicAsSetting(headerString, valueString) {
        const headerStyle = new PIXI.TextStyle({
            fontFamily: OpenSans_1.OpenSans.FAMILY,
            fontSize: 20,
            fontStyle: FontStatics_1.FontStyle.NORMAL,
            fontWeight: FontStatics_1.FontWeight.LIGHT,
            fill: 0x000000,
        });
        let valueStyle = new PIXI.TextStyle({
            fontFamily: OpenSans_1.OpenSans.FAMILY,
            fontSize: 35,
            fontStyle: FontStatics_1.FontStyle.NORMAL,
            fontWeight: FontStatics_1.FontWeight.NORMAL,
            fill: 0x000000,
        });
        const header = new Label_1.Label(headerString, headerStyle);
        const value = new Label_1.Label(valueString, valueStyle);
        GuiLayout_1.GuiLayout.align([header, value], 0, GuiLayout_1.Align.CENTER, GuiLayout_1.Direction.VERTICAL);
        const container = new PIXI.Container();
        container.addChild(header, value);
        container.name = headerString;
        return container;
    }
    createOption(headerString, valueString) {
        const headerStyle = new PIXI.TextStyle({
            fontFamily: OpenSans_1.OpenSans.FAMILY,
            fontSize: 20,
            fontStyle: FontStatics_1.FontStyle.NORMAL,
            fontWeight: FontStatics_1.FontWeight.NORMAL,
            fill: 0x000000,
        });
        let valueStyle = new PIXI.TextStyle({
            fontFamily: OpenSans_1.OpenSans.FAMILY,
            fontSize: 20,
            fontStyle: FontStatics_1.FontStyle.NORMAL,
            fontWeight: FontStatics_1.FontWeight.BOLD,
            fill: 0x000000,
        });
        const header = new Label_1.Label(headerString, headerStyle);
        const value = new Label_1.Label(valueString, valueStyle);
        GuiLayout_1.GuiLayout.align([header, value], 10, GuiLayout_1.Align.LEFT, GuiLayout_1.Direction.HORIZONTAL);
        const container = new PIXI.Container();
        container.addChild(header, value);
        container.name = headerString;
        return container;
    }
    createOneLabelOption(valueString) {
        let valueStyle = new PIXI.TextStyle({
            fontFamily: OpenSans_1.OpenSans.FAMILY,
            fontSize: 20,
            fontStyle: FontStatics_1.FontStyle.NORMAL,
            fontWeight: FontStatics_1.FontWeight.BOLD,
            fill: 0x000000,
        });
        const value = new Label_1.Label(valueString, valueStyle);
        value.anchor.set(0, 0.5);
        const container = new PIXI.Container();
        container.addChild(value);
        return container;
    }
}
exports.ConfirmBetPopUpView = ConfirmBetPopUpView;
//# sourceMappingURL=ConfirmBetPopUpView.js.map